export class DialogModelSaveoLoader{
    constructor(
    ) {}
  }